import { Action } from '../actions/badge-ads';

const defaultState = {
  isFetching: false,
  byId: {},
  error: undefined,
};

export default function badgeAdsReducer(state = defaultState, action) {
  const { byId } = state;
  const body = action?.payload;

  switch (action?.type) {
    case Action.Badges.BadgeAdsPending:
      return {
        ...state,
        isFetching: true,
      };
    case Action.Badges.BadgeAdsCompleted: {
      const { badgeAds = [] } = body;

      return {
        ...state,
        byId: {
          ...byId,
          ...badgeAds,
        },
        isFetching: false,
      };
    }
    case Action.Badges.BadgeAdsFailed:
      return {
        ...state,
        isFetching: false,
        error: body.message,
      };
    default:
      return state;
  }
}
